<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_vii"></a>Drawing Conclusions</h1>
<p class="author"><strong>Donna Leon</strong></p>
<p class="publisher"><img alt="img" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0f35437c